// Framework and third-party non-UI
import React, { useContext } from 'react';

// Redux, contexts, and local helpers/utils/modules
import { DataGridContext } from './DataGrid';

// Component specific modules (Component-styled, etc.)
import { StyledDataGridHeader } from './DataGrid-styled';

// App components

// Third-party components (buttons, icons, etc.)

const DataGridHeader: React.FC = ({ children }) => {
  const dataGridContext = useContext(DataGridContext);
  return (
    <StyledDataGridHeader {...dataGridContext}>{children}</StyledDataGridHeader>
  );
};

export default DataGridHeader;
